import type { DataLayer } from '../DataLayer';
import { filterBlanks } from '../utils/filterBlanks';

export type PageTitle =
  | 'home'
  | 'search results'
  | 'job details'
  | 'email to a friend'
  | 'email to a friend success'
  | 'Global Landing Page';

export const mapCurrentPageTitle = (currentPage: PageTitle): DataLayer =>
  filterBlanks({
    currentPage,
  });
